import styled from "styled-components";

export const Button = styled.button`
  width: ${(props) => props.width}px;
  height: 52px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.bg || "#fff"};
  border-radius: 10px;
  color: ${(props) => props.color || "#000"};
  font-size: 18px;
  outline: none;
  border: none;
  cursor: pointer;

  &.question-prev, &.restart{
    border: 1px solid mediumpurple;
    color: mediumpurple;
  }
`;
